<script lang="ts">

    /* IMPORTS --------------------------------------------------------------------------------- */

    import { useNavigate } from 'svelte-navigator';

    import {
        ADDRESS_API,
        ADDRESS_STORE,
        SUBSCRIPTION_API,
        SUBSCRIPTION_STORE,
        SESSION_ORGANIZATION,
        SESSION_USER,
        IS_AUTHENTICATED,
        IS_ORGANIZATION_APPROVED,
    } from '@smatch/cassiopeia-web-components';

    import { onMount } from 'svelte';

    /* TYPES ----------------------------------------------------------------------------------- */

    import type { Organization, Addresses, Address, Subscriptions, Subscription } from 'src/app/types';

    type SessionOrganization = Organization | null;
    type SessionAddresses = Addresses | null;
    type SessionSubscriptions = Subscriptions | null;

    /* INITIALIZE ------------------------------------------------------------------------------ */

    const navigate = useNavigate();

    /* INTERNALS ------------------------------------------------------------------------------- */

    // eslint-disable-next-line complexity, max-statements, max-lines-per-function
    const onStateChange = (
        organization: SessionOrganization,
        addresses: SessionAddresses,
        subscriptions: SessionSubscriptions,
    ): void => {

        const { pathname: PATH_NAME } = window.location;

        if (organization === null) {
            navigate('/authentication');
            return;
        }

        if (Array.isArray(subscriptions) && subscriptions.length === 0) {
            if (PATH_NAME !== '/onboarding/preferences') {
                navigate('/onboarding/preferences');
            }
            return;
        }

        if (Array.isArray(organization.types) && organization.types.length === 0) {
            if (PATH_NAME !== '/onboarding/organization') {
                navigate('/onboarding/organization');
            }
            return;
        }

        if (Array.isArray(addresses) && addresses.length === 0) {
            if (PATH_NAME !== '/onboarding/organization') {
                navigate('/onboarding/organization');
            }
            return;
        }

        if (PATH_NAME !== '/onboarding/success') {
            navigate('/onboarding/success');
        }
    };

    $: onStateChange(
        $SESSION_ORGANIZATION as SessionOrganization,
        Object.values($ADDRESS_STORE as Record<string, Address>) as SessionAddresses,
        Object.values($SUBSCRIPTION_STORE as Record<string, Subscription>) as SessionSubscriptions,
    );

    onMount((): void => {
        void Promise.all([
            // eslint-disable-next-line array-element-newline
            ADDRESS_API.filterAddresses({ organizationKey: $SESSION_ORGANIZATION?._.key }),
            SUBSCRIPTION_API.filterSubscriptions({ ownerKey: $SESSION_USER?._.key }),
        ]);
    });

</script>

{#if $IS_AUTHENTICATED && !$IS_ORGANIZATION_APPROVED}
    <slot />
{/if}